import { NgModule } from '@angular/core';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';

const MATERIAL_MODULES = [
  MatDatepickerModule,
  MatDialogModule,
  MatNativeDateModule
];

@NgModule({
  exports: MATERIAL_MODULES,
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-SV' }
  ]
})
export class MaterialModule {}
